import React from "react";
import { H1 } from "../Headers";
import styled from "styled-components";
import QueryString from "query-string";
import ContactAddForm from "../contacts/ContactAddForm";
import { withRouter, RouteComponentProps } from "react-router";

const Container = styled.div`
  max-width: 800px;
  margin: 3em auto;
`;

export interface IAddContactsPageProps extends RouteComponentProps {}

const AddContact = (props: IAddContactsPageProps) => {
  const {
    location: { search },
  } = props;

  const { returnUrl } = QueryString.parse(search);

  return (
    <Container>
      <H1>Add New User</H1>
      <ContactAddForm returnUrl={returnUrl as string} />
    </Container>
  );
};

export default withRouter(AddContact);
